var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import request from './request';
import { isEmptyArray, sort } from '../utils/utils';
import { findAttributeDependencies } from '../utils/AttributeSelectorUtils';
var PREFERRED_NUMBER_OF_VALUES = 10;
export var getRuleSet = function getRuleSet(sku) {
  return request("https://rule.products.cimpress.io/v1/ruleSets?referenceId=" + sku);
};
export var getRequiredInputs = function getRequiredInputs(sku) {
  return request("https://priceinput.ff.cimpress.io/api/v1/requiredinputs/" + sku);
};

var getDefaults = function getDefaults(values) {
  return values.length > PREFERRED_NUMBER_OF_VALUES ? values.slice(0, PREFERRED_NUMBER_OF_VALUES) : null;
};

var pushToDefaults = function pushToDefaults(defaults, number) {
  if (defaults.length < PREFERRED_NUMBER_OF_VALUES) {
    defaults.push(number);
  }
};

var getMoq = function getMoq(inputRanges) {
  var moq;

  if (!isEmptyArray(inputRanges)) {
    inputRanges.forEach(function (range) {
      moq = moq && moq < range.minimum ? moq : range.minimum;
    });
  }

  return moq;
};

var parseAttributes = function parseAttributes(name, inputValues, inputRa, scope, attributeValues) {
  var lowerCaseName = name.toLowerCase();
  var allAttributeValues = attributeValues;
  var inputRanges = inputRa; // Value Attributes with more than 1 value

  if (!isEmptyArray(inputValues) && inputValues.length > 1) {
    var values = inputValues.map(function (value) {
      return value.value;
    });
    sort(values);
    var defaults = getDefaults(values);
    allAttributeValues[lowerCaseName] = {
      key: name,
      class: scope,
      values: values,
      defaults: defaults
    };
  } else if (!isEmptyArray(inputRanges)) {
    var rangeFound = false;

    for (var i = 0; i < inputRanges.length; i += 1) {
      var range = inputRanges[i];

      if (range.increment) {
        rangeFound = true;
        break;
      } else if (range.minimum !== range.maximum) {
        inputRanges[i].increment = 1;
        rangeFound = true;
        break;
      }
    } // Ranged Attributes


    if (rangeFound) {
      var fixedValues_1 = [];
      var ranges_1 = [];
      var defaults_1 = [];
      var perRange_1 = PREFERRED_NUMBER_OF_VALUES / inputRanges.length;
      perRange_1 = perRange_1 < 2 ? 2 : perRange_1;
      inputRanges.forEach(function (range) {
        var minimum = range.minimum,
            maximum = range.maximum;
        var increment = range.increment;
        increment = increment || 1;
        var currentAllocation = perRange_1;

        if (currentAllocation > 0 && !defaults_1.includes(minimum)) {
          pushToDefaults(defaults_1, minimum);
          currentAllocation -= 1;
        }

        if (maximum !== minimum) {
          if (maximum !== null) {
            ranges_1.push({
              minimum: minimum,
              maximum: maximum,
              increment: increment
            });

            if (currentAllocation > 0 && !defaults_1.includes(maximum)) {
              pushToDefaults(defaults_1, maximum);
              currentAllocation -= 1;
            }

            if (currentAllocation > 0) {
              var diff = (maximum - minimum) / perRange_1;
              var step = Math.round(diff / increment) * increment;
              var begin = minimum === 1 && step > 9 ? 0 : minimum;

              for (var i = 1; i <= currentAllocation; i += 1) {
                var next = parseFloat((begin + i * step).toFixed(2));

                if (!defaults_1.includes(next)) {
                  pushToDefaults(defaults_1, next);
                }
              }
            }
          } else {
            ranges_1.push({
              minimum: minimum,
              maximum: 'infinity',
              increment: increment
            });
            var begin = minimum === 1 ? 0 : minimum;
            var step = increment;

            if (step < 100 && 100 % step === 0) {
              step = 100;
              begin = minimum < 100 ? 100 : minimum;
            }

            for (var i = 1; i <= currentAllocation; i += 1) {
              var next = parseFloat((begin + i * step).toFixed(2));

              if (!defaults_1.includes(next)) {
                pushToDefaults(defaults_1, next);
              }
            }
          }
        } else {
          fixedValues_1.push(minimum);
        }
      });

      if (defaults_1.length > 0) {
        sort(defaults_1);
      } // Set toolTip text


      var toolTip = null;

      if (fixedValues_1.length > 0) {
        sort(fixedValues_1);
        toolTip = "Must be " + fixedValues_1.join(', ') + "\n";
      }

      if (ranges_1.length > 0) {
        if (toolTip) {
          toolTip += 'or must be between\n';
        } else {
          toolTip = 'Must be between\n';
        }

        var rangeTexts_1 = [];
        ranges_1 = ranges_1.sort(function (a, b) {
          return a.minimum === b.minimum ? a.maximum - b.maximum : a.minimum - b.minimum;
        });
        ranges_1.forEach(function (range) {
          var minimum = range.minimum,
              maximum = range.maximum,
              increment = range.increment;
          rangeTexts_1.push(minimum + " and " + maximum + " in increments of " + increment);
        });
        toolTip += rangeTexts_1.join(',\n');
      }

      allAttributeValues[lowerCaseName] = {
        key: name,
        class: scope,
        defaults: defaults_1,
        isRange: true,
        values: {
          ranges: ranges_1,
          fixedValues: fixedValues_1
        },
        toolTip: toolTip
      };
    } // Ranged Attributes that are really value attributes (With more than 1 value)
    else if (inputRanges.length > 1) {
        var values = inputRanges.map(function (range) {
          return range.minimum;
        });
        sort(values);
        var defaults = getDefaults(values);
        allAttributeValues[lowerCaseName] = {
          key: name,
          class: scope,
          values: values,
          defaults: defaults
        };
      }
  }
};

export var getRuleSetInfoService = function getRuleSetInfoService(sku) {
  return __awaiter(void 0, void 0, void 0, function () {
    var moq, allAttributeValues, derivedAttributes, requiredAttributes, isQuantityDerived, ruleSetPromise, requiredInputsPromise, combinedResult, _a, ruleSetResponse, requiredInputs, ruleSet, quantityAttribute, ruleSetInfo;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          allAttributeValues = {};
          derivedAttributes = {};
          requiredAttributes = {};
          isQuantityDerived = false;
          ruleSetPromise = getRuleSet(sku);
          requiredInputsPromise = getRequiredInputs(sku);
          return [4
          /*yield*/
          , Promise.all([ruleSetPromise, requiredInputsPromise])];

        case 1:
          combinedResult = _b.sent();
          _a = __read(combinedResult, 1), ruleSetResponse = _a[0];
          requiredInputs = combinedResult[1];
          ruleSet = !isEmptyArray(ruleSetResponse) ? ruleSetResponse.find(function (item) {
            return item.authoritative;
          }) : undefined;
          requiredInputs = requiredInputs && requiredInputs.inputs ? requiredInputs.inputs : undefined;

          if (!ruleSet || !requiredInputs) {
            return [2
            /*return*/
            , undefined];
          }

          if (ruleSet) {
            requiredInputs = requiredInputs.filter(function (item) {
              var name = item.name;
              name = name.toLowerCase();
              var result = findAttributeDependencies(name, ruleSet);

              if (result && result.length > 1 && !derivedAttributes[name]) {
                derivedAttributes[name] = 1;
                result.forEach(function (value) {
                  var lowerCaseValue = value.toLowerCase();

                  if (lowerCaseValue !== name && !requiredAttributes[lowerCaseValue]) {
                    requiredAttributes[lowerCaseValue] = 1;
                  }
                });

                if (name === 'quantity') {
                  isQuantityDerived = true;
                  return true;
                }

                return false;
              }

              return true;
            });
          }

          if (ruleSet && !isEmptyArray(ruleSet.whiteList)) {
            ruleSet.whiteList.forEach(function (item) {
              var attributeKey = item.attributeKey,
                  attributeValues = item.attributeValues,
                  attributeRanges = item.attributeRanges;
              var lowerCaseName = attributeKey.toLowerCase();

              if (lowerCaseName === 'quantity') {
                moq = getMoq(attributeRanges);
              }

              if (!allAttributeValues[lowerCaseName] && requiredAttributes[lowerCaseName]) {
                parseAttributes(attributeKey, attributeValues, attributeRanges, item.class, allAttributeValues);
              }
            });
          }

          if (!isEmptyArray(requiredInputs)) {
            requiredInputs.forEach(function (item) {
              var name = item.name,
                  inputValues = item.inputValues,
                  inputRanges = item.inputRanges,
                  scope = item.scope;
              var lowerCaseName = name.toLowerCase();

              if (!moq && lowerCaseName === 'quantity') {
                moq = getMoq(inputRanges);
              }

              if (!allAttributeValues[lowerCaseName]) {
                parseAttributes(name, inputValues, inputRanges, scope, allAttributeValues);
              }
            });
          }

          requiredInputs.forEach(function (input) {
            var name = input.name,
                scope = input.scope;
            var inputValues = input.inputValues;
            var lowerCaseAttributeKey = name.toLowerCase();
            inputValues = inputValues.map(function (item) {
              return item.value;
            });

            if (!allAttributeValues[lowerCaseAttributeKey] && inputValues && inputValues.length > 1) {
              var defaults = getDefaults(inputValues);
              allAttributeValues[lowerCaseAttributeKey] = {
                key: name,
                class: scope,
                values: inputValues,
                defaults: defaults
              };
            }
          });
          quantityAttribute = allAttributeValues.quantity;

          if (isQuantityDerived) {
            delete allAttributeValues.quantity;
          }

          derivedAttributes = Object.keys(derivedAttributes);
          ruleSetInfo = {
            moq: moq,
            ruleSet: ruleSet,
            derivedAttributes: derivedAttributes,
            allAttributeValues: allAttributeValues,
            requiredInputs: requiredInputs,
            quantityAttribute: quantityAttribute
          };
          return [2
          /*return*/
          , [sku, ruleSetInfo]];
      }
    });
  });
};